export const iconFontAwesomeGamingHandFist = (
	<i className="fa-solid fa-hand-fist"></i>
);
